import React, { useEffect, useState } from 'react';
import { User } from 'lucide-react';
import Logo from '../assets/logo.png'; // Assuming you have the logo image
import LanguageSwitcher from '../Components/LanguageSwitcher'

export default function Header() {


    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Update state on window resize
    useEffect(() => {

        if (window.gtranslateSettings && window.GTranslate) {
            window.GTranslate.init(window.gtranslateSettings);
        }


        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    function logout() {
        localStorage.removeItem('AV_User_Data')
        window.location.reload()

    }


    return (
        <div className='w-100 mb-2 d-flex flex-row justify-content-between' >
            {isMobile ? <img style={{ height: '40px' }} src={Logo} /> : ""}


            <div className={`mb-2 d-flex flex-row align-items-center justify-content-end gap-2 ${!isMobile ? 'w-100' : ''}`}>

                {isMobile ?"":<LanguageSwitcher />}
                <button style={{ float: 'right' }} onClick={() => logout()}>Logout</button>
                {isMobile ? <div className='avatar' onClick={() => window.location.href = '/profile'} ><User /></div> : ""}
            </div>
        </div>
    )
}
